import { IPromise, IQService, noop } from "angular";
import FontFaceObserver from "fontfaceobserver";

export class FontDownloaderProvider {
  private googleFonts: string[] = [];

  addGoogleFont(...fontFamilies: string[]): void {
    this.googleFonts.push(...fontFamilies);
  }

  get $get(): unknown {
    return [
      "$q",
      ($q: IQService) => {
        return new FontDownloader($q, { googleFonts: this.googleFonts });
      },
    ];
  }
}

export interface IFontDownloader {
  loadFonts(...fonts: string[]): IPromise<void>;
}

export class FontDownloader implements IFontDownloader {
  private loadedFonts: Record<string, Promise<void>> = {};

  constructor(private $q: IQService, private fonts: { googleFonts: string[] }) {}

  loadFonts(...fonts: string[]): IPromise<void> {
    const customFonts = fonts.filter((fontFamily) => this.fonts.googleFonts.includes(fontFamily));
    if (!customFonts.length) {
      return this.$q.resolve();
    }

    const nonLoadedGoogleFonts = customFonts.filter((fontFamily) => this.fonts.googleFonts.includes(fontFamily) && !this.loadedFonts[fontFamily]);
    if (nonLoadedGoogleFonts.length) {
      this.loadGoogleFonts(nonLoadedGoogleFonts);
    }

    const promises = customFonts.map((fontFamily) => this.loadedFonts[fontFamily] || (this.loadedFonts[fontFamily] = new FontFaceObserver(fontFamily).load()));
    return this.$q.when(Promise.all(promises)).then(noop);
  }

  private loadGoogleFonts(fonts: string[]): void {
    const url = new URL("https://fonts.googleapis.com/css2");
    for (const fontFamily of fonts) {
      url.searchParams.append("family", fontFamily);
      url.searchParams.append("display", "swap");
    }

    const linkEl = document.createElement("link");
    linkEl.rel = "stylesheet";
    linkEl.type = "text/css";
    linkEl.href = url.toString();
    document.body.appendChild(linkEl);
  }
}
